import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApresentacaoService } from '../../services/apresentacao.service';
import {  ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { Apresentacao, PfIndicator, PfIndTable } from '../../models/apresentacao.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';

@Component({
  selector: 'app-apresentacao-pauta',
  templateUrl: './apresentacao-pauta.component.html',
  styleUrls: ['./apresentacao-pauta.component.scss']
})
export class ApresentacaoPautaComponent extends BaseFormComponent<Apresentacao> implements OnInit {
  
//EXEMPLOS DE REUNIÃO:
//766
//762 -> Demandas


  id:number;
  filters: any;
  polar= {'1':'Se maior, melhor', '3':'Se menor, melhor'};
  @Input() print:boolean = false;
  @ViewChild('carousel', { static: true }) carousel!: ElementRef;
  currentIndex = 0;
  visibleItems = 3;
  isDragging = false;
  startX = 0;
  startScrollIndex = 0;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ApresentacaoService,
    private apresentacaoResolverId: ApresentacaoResolverId
  ) {
    super(activatedRoute); 
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }

  start(){
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.filters = data.filters;
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
  }

  get canGoPrevious(): boolean {
    return this.currentIndex > 0;
  }

  get canGoNext(): boolean {
    return this.currentIndex < this.entity?.agencyPf.length - this.visibleItems;
  }

  next(): void {
    if (this.canGoNext) {
      this.currentIndex++;
      this.updateScroll();
    }
  }

  previous(): void {
    if (this.canGoPrevious) {
      this.currentIndex--;
      this.updateScroll();
    }
  }

  startDrag(event: MouseEvent): void {
    this.isDragging = true;
    this.startX = event.clientX;
    this.startScrollIndex = this.currentIndex;
    this.carousel.nativeElement.style.cursor = 'grabbing';
  }

  onDrag(event: MouseEvent): void {
    if (!this.isDragging) return;

    const deltaX = this.startX - event.clientX;
    const itemWidth = this.carousel.nativeElement.children[0].offsetWidth;

    const moveIndex = Math.round(deltaX / itemWidth); // Quantos itens foram arrastados
    let newIndex = this.startScrollIndex + moveIndex;

    // Garante que o índice permaneça nos limites
    if (newIndex < 0) newIndex = 0;
    if (newIndex > this.entity?.agencyPf?.length - this.visibleItems) {
      newIndex = this.entity?.agencyPf?.length - this.visibleItems;
    }

    this.currentIndex = newIndex;
    this.updateScroll();
  }

  endDrag(): void {
    this.isDragging = false;
    this.carousel.nativeElement.style.cursor = 'grab';
  }

  private updateScroll(): void {
    const itemWidth = this.carousel.nativeElement.children[0].offsetWidth;
    const scrollAmount = this.currentIndex * itemWidth;
    this.carousel.nativeElement.style.transform = `translateX(-${scrollAmount}px)`;
  }

  getMinutes(agency): number{
    var sum = agency?.tb_org_orgao_many?.reduce(function(a, b){
      var bChild = b?.ac_meeting_pf_agency_child;
      var bMinutes = bChild?.length > 0 ? bChild[0]?.minutes : 0;
      return a + bMinutes;
    }, 0);
    return sum * 60000;
  }
  get description():string {
    var description = this.entity?.acMeeting?.description;
    var formatedDescription = description?.replace(/\n\s*-\s*/g, '\n• ')
    return formatedDescription;
  }
}
